import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import moment from "moment";
import defaultitineraryimage from "../../../assets/Images/default-itinerary-image.jpg";

export const getAllFITBookings = createAsyncThunk(
  "PackageBooking/FindAllPackageBooking",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PackageBooking/FindAllPackageBooking`,
        formData
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Package Bookings:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createFITBooking = createAsyncThunk(
  "PackageBooking/InsertPackageBooking",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PackageBooking/InsertPackageBooking`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating package booking:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateFITBooking = createAsyncThunk(
  "PackageBooking/UpdatePackageBooking",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PackageBooking/UpdatePackageBooking`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating package booking:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteFITBooking = createAsyncThunk(
  "PackageBooking/DeletePackageBooking",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PackageBooking/DeletePackageBooking`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting package booking:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getFITBookingByID = createAsyncThunk(
  "PackageBooking/FindByIDPackageBooking",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PackageBooking/FindByIDPackageBooking`,
        formData
      );
      const result = response.data?.Data as any;
      return {
        ...result,
        BookingDate: result?.BookingDate
          ? moment(result?.BookingDate, "YYYY-MM-DD").toDate()
          : "",
        TourStartDate: result?.TourStartDate
          ? moment(result?.TourStartDate, "YYYY-MM-DD").toDate()
          : "",
        TourEndDate: result?.TourEndDate
          ? moment(result?.TourEndDate, "YYYY-MM-DD").toDate()
          : "",
        PickUpDate: result?.PickUpDate
          ? moment(result?.PickUpDate, "YYYY-MM-DD").toDate()
          : "",
        PickUpTime: result?.PickUpTime
          ? moment(result?.PickUpTime, "HH:mm:ss").toDate()
          : "",
        DropPlace: result?.DropPlace,
        DropDate: result?.DropDate
          ? moment(result?.DropDate, "YYYY-MM-DD").toDate()
          : "",
        DropTime: result?.DropTime
          ? moment(result?.DropTime, "HH:mm:ss").toDate()
          : "",
        AccommodationConversionRate: result?.AccommodationConversionRate
          ? +result?.AccommodationConversionRate
          : 1,
        TransportaionConversionRate: result?.TransportaionConversionRate
          ? +result?.TransportaionConversionRate
          : 1,
        MiscellaneousConversionRate: result?.MiscellaneousConversionRate
          ? +result?.MiscellaneousConversionRate
          : 1,
        SightSeenConversionRate: result?.SightSeenConversionRate
          ? +result?.SightSeenConversionRate
          : 1,
        AccommodationCurrencyID: result?.AccommodationCurrencyID
          ? +result?.AccommodationCurrencyID
          : 1,
        TransportaionCurrencyID: result?.TransportaionCurrencyID
          ? +result?.TransportaionCurrencyID
          : 1,
        MiscellaneousCurrencyID: result?.MiscellaneousCurrencyID
          ? +result?.MiscellaneousCurrencyID
          : 1,
        SightSeenCurrencyID: result?.SightSeenCurrencyID
          ? +result?.SightSeenCurrencyID
          : 1,
        Accommodations: result?.Accommodations
          ? result?.Accommodations?.map((accommodation: any) => {
              return {
                Place: accommodation?.Place ? accommodation?.Place : "",
                PlaceID: accommodation?.PlaceID ? accommodation?.PlaceID : null,
                HotelName: accommodation?.HotelName
                  ? accommodation?.HotelName
                  : "",
                RoomType: accommodation?.RoomType
                  ? accommodation?.RoomType
                  : "",
                RoomCategoryName: accommodation?.RoomCategoryName
                  ? accommodation?.RoomCategoryName
                  : "",
                HotelCategoryID: accommodation?.HotelCategoryID
                  ? accommodation?.HotelCategoryID
                  : null,
                MealType: accommodation?.MealType
                  ? accommodation?.MealType
                  : "",
                Hotel:
                  accommodation?.Hotel && accommodation?.Hotel !== "0"
                    ? accommodation?.Hotel
                    : "",
                hotel_options: accommodation?.hotel_options
                  ? accommodation?.hotel_options
                  : [],
                place_options: accommodation?.place_options
                  ? accommodation?.place_options
                  : [],
                CheckInDate: accommodation?.CheckInDate
                  ? moment(accommodation?.CheckInDate, "YYYY-MM-DD").toDate()
                  : "",
                CheckOutDate: accommodation?.CheckOutDate
                  ? moment(accommodation?.CheckOutDate, "YYYY-MM-DD").toDate()
                  : "",
                RoomTypeID: accommodation?.RoomTypeID
                  ? +accommodation?.RoomTypeID
                  : null,
                MealTypeID: accommodation?.MealTypeID
                  ? +accommodation?.MealTypeID
                  : null,
                TotalRoom: accommodation?.TotalRoom
                  ? +accommodation?.TotalRoom
                  : null,
                AccomodationID: accommodation?.AccomodationID
                  ? +accommodation?.AccomodationID
                  : null,
                HotelAmount: accommodation?.HotelAmount
                  ? +accommodation?.HotelAmount
                  : null,
                HotelRate: accommodation?.HotelRate
                  ? +accommodation?.HotelRate
                  : null,
              };
            })
          : [],
        Transportations: result?.Transportations
          ? result?.Transportations?.map((transportation: any) => {
              return {
                VehicleTypeID: transportation?.VehicleTypeID
                  ? +transportation?.VehicleTypeID
                  : null,
                Place: transportation?.Place ? transportation?.Place : "",
                PlaceID: transportation?.PlaceID
                  ? transportation?.PlaceID
                  : null,
                VehicleType: transportation?.VehicleType
                  ? transportation?.VehicleType
                  : "",
                FromDate: transportation?.FromDate
                  ? moment(transportation?.FromDate, "YYYY-MM-DD")?.toDate()
                  : "",
                ToDate: transportation?.ToDate
                  ? moment(transportation?.ToDate, "YYYY-MM-DD")?.toDate()
                  : "",
                Rate: transportation?.Rate ? +transportation?.Rate : null,
              };
            })
          : [],
        Miscellaneous: result?.Miscellaneous
          ? result?.Miscellaneous?.map((miscellaneous: any) => {
              return {
                Title: miscellaneous?.Title ? miscellaneous?.Title : "",
                TotalAmount: miscellaneous?.TotalAmount
                  ? +miscellaneous?.TotalAmount
                  : null,
              };
            })
          : [],
        SightSeen: result?.SightSeen
          ? result?.SightSeen?.map((sightseen: any) => {
              return {
                SightSeenID: sightseen?.SightSeenID
                  ? +sightseen?.SightSeenID
                  : null,
                Rate: sightseen?.Rate ? +sightseen?.Rate : null,
                SightSeenName: sightseen?.SightSeenName
                  ? sightseen?.SightSeenName
                  : "",
              };
            })
          : [],
        TourItinerary: result?.Itinary
          ? result?.Itinary?.map((itinerary: any) => {
              return {
                FITBookingID: itinerary?.FITBookingID
                  ? +itinerary?.FITBookingID
                  : null,
                DayNo: itinerary?.DayNo ? +itinerary?.DayNo : null,
                PlaceID: itinerary?.PlaceID ? +itinerary?.PlaceID : null,
                ItinaryID: itinerary?.ItinaryID ? +itinerary?.ItinaryID : null,
                Description: itinerary?.Description
                  ? itinerary?.Description
                  : "",
                Facilty: itinerary?.Facilty ? itinerary?.Facilty : "",
                ItineraryTitle: itinerary?.ItineraryTitle
                  ? itinerary?.ItineraryTitle
                  : "",
                Place: itinerary?.Place ? itinerary?.Place : "",
                FacilityName: itinerary?.FacilityName
                  ? itinerary?.FacilityName
                  : "",
                ItineraryImage: itinerary?.ItineraryImage
                  ? itinerary?.ItineraryImage
                  : defaultitineraryimage,
              };
            })
          : [],
        HotelRooms: result?.HotelRooms ? result?.HotelRooms : [],
      } as any;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching package booking:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const generateFITBookingByQuotationID = createAsyncThunk(
  "PackageBooking/InsertPackageBookingByQuotationID",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PackageBooking/InsertPackageBookingByQuotationID`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error generating package booking:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const FITBookingCancel = createAsyncThunk(
  "PackageBooking/InsertPackageBookingCancelledPaxInfo",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PackageBooking/InsertPackageBookingCancelledPaxInfo`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error generating package booking:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const sendFITBookingByEmail = createAsyncThunk(
  "PackageBooking/SendPackageBooking",
  async (payload: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PackageBooking/SendPackageBooking`,
        payload
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error sending FIT booking by email:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getFITBookingDetailsForCancellation = createAsyncThunk(
  "PackageBooking/PackageBookingViewForCancellation",
  async (TourBookingNo: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PackageBooking/PackageBookingViewForCancellation`,
        { TourBookingNo: TourBookingNo }
      );
      const result = response.data?.Data as any;
      return {
        TourBookingNo: result?.TourBookingNo,
        Name: result?.Name,
        MobileNo: result?.MobileNo,
        EmailID: result?.EmailID,
        TourStartDate: result?.TourStartDate
          ? moment(result?.TourStartDate, "YYYY-MM-DD").toDate()
          : "",
        TourEndDate: result?.TourEndDate
          ? moment(result?.TourEndDate, "YYYY-MM-DD").toDate()
          : "",
        NoOfNights: result?.NoOfNights,
        TotalAdults: result?.TotalAdults,
        TotalCWB: result?.TotalCWB,
        TotalCNB: result?.TotalCNB,
        PickUpPlace: result?.PickUpPlace,
        PickUpDate: result?.PickUpDate
          ? moment(result?.PickUpDate, "YYYY-MM-DD").toDate()
          : "",
        DropPlace: result?.DropPlace,
        DropDate: result?.TourStartDate
          ? moment(result?.TourStartDate, "YYYY-MM-DD").toDate()
          : "",
      } as any;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching package booking:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createFITBookingStep2 = createAsyncThunk(
  "PackageBooking/InsertPackageBookingStep2",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PackageBooking/InsertPackageBookingStep2`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error inserting quotation step 2:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getFindByIDBookingHotelVoucher = createAsyncThunk(
  "PackageBooking/FindByIDBookingHotelVoucher",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PackageBooking/FindByIDBookingHotelVoucher`,
        formData
      );
      const result = response.data?.Data as any;
      return {
        ID: result?.ID,
        TourBookingNo: result?.TourBookingNo,
        BookingDate: result?.BookingDate,
        FirstName: result?.FirstName,
        LastName: result?.LastName,
        MobileNo: result?.MobileNo,
        TotalAdult: result?.TotalAdult,
        TotalCWB: result?.TotalCWB,
        TotalCNB: result?.TotalCNB,
        TotalPax: result?.TotalPax,
        TotalRoom: result?.TotalRoom,
        RoomTypeID: result?.RoomTypeID,
        RoomType: result?.RoomType,
        MealTypeID: result?.MealTypeID,
        MealType: result?.MealType,
        Hotel: result?.Hotel,
        HotelName: result?.HotelName,
        PhoneNo: result?.PhoneNo,
        Address: result?.Address,
        CheckInDate: result?.CheckInDate,
        CheckOutDate: result?.CheckOutDate,
        NoofNights: result?.NoofNights,
        TermsAndCondition: result?.TermsAndCondition,
        CompanyDetails: result?.CompanyDetails,
      } as any;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching package booking:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
